import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';
import { EXTENDED_STALE_TIME } from '@/constants/constants';
import { type ProductName, ProductNames } from '@/constants/ProductNames';

export const creditFeaturesQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.creditFeatures,
    queryFn: API.credit.getFeatures,
    staleTime: EXTENDED_STALE_TIME,
  });

export const featuresQueryOptions = (productName: ProductName) => {
  const featuresQueryConfig = {
    [ProductNames.CREDIT]: {
      queryKey: queryKeys.creditFeatures,
      queryFn: API.credit.getFeatures,
    },
    [ProductNames.DEBT_CONSOLIDATION]: {
      queryKey: queryKeys.debtConsolidationFeatures,
      queryFn: API.debtConsolidation.getFeatures,
    },
    [ProductNames.LOAN]: {
      queryKey: queryKeys.loanFeatures,
      queryFn: API.SE.loan.getFeaturesSteps,
    },
  };

  return queryOptions({
    ...featuresQueryConfig[productName],
    staleTime: EXTENDED_STALE_TIME,
  });
};
